import { render, staticRenderFns } from "./ivy.vue?vue&type=template&id=ac9b7802"
import script from "./ivy.vue?vue&type=script&lang=ts"
export * from "./ivy.vue?vue&type=script&lang=ts"
import style0 from "./ivy.vue?vue&type=style&index=0&id=ac9b7802&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports